module.exports = __webpack_public_path__ + "static/img/stl_qr_back_1x.fa88640.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stl_qr_back_1x.png
// module id = hsQa
// module chunks = 1